import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Popover_index_js_687cf573__ from "../../Popover/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__ from "../../Text/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__IconButton_index_js_793c8d01__ from "../../IconButton/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__ from "../../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__OverlayTitle_variants_js_927c1a6c__ from "./OverlayTitle.variants.js";
function OverlayTitle({ heading, subHeading, backIconName = 'arrow_back', popOverText = '', handleClose }) {
    const { root, headingClass, subHeadingClass } = (0, __WEBPACK_EXTERNAL_MODULE__OverlayTitle_variants_js_927c1a6c__.overlayTitleVariants)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "flex flex-col items-center justify-between pb-4",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: root(),
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__IconButton_index_js_793c8d01__.IconButton, {
                            iconName: backIconName,
                            type: "plainPrimary",
                            shadow: true,
                            size: "md",
                            "aria-label": "Close Drawer",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: headingClass(),
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__.Span, {
                            className: "",
                            textStyle: "heading4",
                            children: heading
                        })
                    }),
                    popOverText ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "pt-1",
                        "data-testid": "overlay-title-popover-container",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Popover_index_js_687cf573__.Popover, {
                            triggerNode: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__.CdnIcon, {
                                palette: "primary",
                                className: "fill-none",
                                iconName: "info",
                                size: "20"
                            }),
                            side: "bottom",
                            children: popOverText
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__.Span, {
                textStyle: "body1",
                className: subHeadingClass(),
                children: subHeading
            })
        ]
    });
}
export { OverlayTitle };
